var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-comparison-table"},[_c('div',{staticClass:"row-header"},[_c('vnodes',{attrs:{"vnodes":this.$slots.rowHeader}})],1),_c('vnodes',{attrs:{"vnodes":this.$slots.column}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }